(function () {
  if (window.rizznovaProductUiLoaded) {
    document.dispatchEvent(new CustomEvent('rz:products:rendered'));
    return;
  }
  window.rizznovaProductUiLoaded = true;

  var wishlistKey = 'rizznova:wishlist';

  function readWishlist() {
    try {
      var saved = JSON.parse(window.localStorage.getItem(wishlistKey) || '[]');
      return saved.map(function (item) {
        return typeof item === 'string' ? { id: item, handle: '' } : item;
      }).filter(function (item) { return item && item.id && item.handle; });
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    window.localStorage.setItem(wishlistKey, JSON.stringify(items));
  }

  function wishlistIds(items) {
    return items.map(function (item) { return item.id; });
  }

  function syncWishlistButtons() {
    var items = readWishlist();
    var ids = wishlistIds(items);
    document.querySelectorAll('[data-rz-product-card]').forEach(function (card) {
      var productId = card.getAttribute('data-product-id');
      var isActive = ids.indexOf(productId) !== -1;
      card.classList.toggle('is-wished', isActive);
      var button = card.querySelector('[data-rz-wishlist-toggle]');
      if (button) {
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        button.setAttribute('aria-label', (isActive ? 'Remove ' : 'Add ') + (button.dataset.productTitle || 'product') + (isActive ? ' from favourites' : ' to favourites'));
      }
    });
    document.querySelectorAll('[data-rz-product-favourite]').forEach(function (button) {
      var productId = button.getAttribute('data-product-id');
      var isActive = ids.indexOf(productId) !== -1;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      button.textContent = isActive ? '♥ Added to favourites' : '♡ Add to favourites';
    });
    document.querySelectorAll('[data-rz-wishlist-count]').forEach(function (count) {
      count.textContent = String(items.length);
      count.hidden = items.length === 0;
    });
  }

  function toggleWishlist(card) {
    var productId = card.getAttribute('data-product-id');
    toggleWishlistById(productId, card.getAttribute('data-product-handle'));
  }

  function toggleWishlistById(productId, handle) {
    if (!productId) return;
    var items = readWishlist();
    var ids = wishlistIds(items);
    var index = ids.indexOf(productId);
    if (index === -1) {
      items.push({ id: productId, handle: handle || '' });
    } else {
      items.splice(index, 1);
    }
    writeWishlist(items);
    syncWishlistButtons();
    document.dispatchEvent(new CustomEvent('rz:wishlist:changed'));
  }

  function initializeCardGalleries(root) {
    (root || document).querySelectorAll('[data-rz-card-gallery]').forEach(function (gallery) {
      if (gallery.dataset.rzGalleryReady === 'true') return;
      gallery.dataset.rzGalleryReady = 'true';
      var card = gallery.closest('[data-rz-product-card]');
      var slides = Array.from(gallery.querySelectorAll('[data-rz-card-slide]'));
      var dots = card ? Array.from(card.querySelectorAll('[data-rz-card-dot]')) : [];
      if (slides.length < 2) return;
      var touchStartX = 0;
      var touchStartY = 0;
      var suppressClick = false;
      function activeIndex() {
        return Math.max(0, Math.min(slides.length - 1, Math.round(gallery.scrollLeft / Math.max(gallery.clientWidth, 1))));
      }
      function syncDots() {
        var index = activeIndex();
        dots.forEach(function (dot, dotIndex) { dot.classList.toggle('is-active', dotIndex === index); });
      }
      function go(direction) {
        var index = activeIndex();
        var next = Math.max(0, Math.min(slides.length - 1, index + direction));
        gallery.scrollTo({ left: next * gallery.clientWidth, behavior: 'smooth' });
      }
      gallery.addEventListener('scroll', function () { window.requestAnimationFrame(syncDots); }, { passive: true });
      gallery.addEventListener('touchstart', function (event) {
        var touch = event.touches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        suppressClick = false;
      }, { passive: true });
      gallery.addEventListener('touchend', function (event) {
        var touch = event.changedTouches[0];
        var deltaX = touch.clientX - touchStartX;
        var deltaY = touch.clientY - touchStartY;
        suppressClick = Math.abs(deltaX) > 8 && Math.abs(deltaX) > Math.abs(deltaY);
      }, { passive: true });
      gallery.addEventListener('click', function (event) {
        if (!suppressClick) return;
        event.preventDefault();
        suppressClick = false;
      });
      card.querySelector('[data-rz-card-previous]')?.addEventListener('click', function (event) { event.preventDefault(); event.stopPropagation(); go(-1); });
      card.querySelector('[data-rz-card-next]')?.addEventListener('click', function (event) { event.preventDefault(); event.stopPropagation(); go(1); });
      syncDots();
    });
  }

  function initializeInfiniteScroll() {
    if (!window.matchMedia('(max-width: 760px)').matches || !('IntersectionObserver' in window)) return;

    document.querySelectorAll('[data-rz-collection-grid]').forEach(function (collectionSection) {
      if (collectionSection.dataset.rzInfiniteReady === 'true') return;

      var loader = collectionSection.querySelector('[data-rz-infinite-scroll]');
      var grid = collectionSection.querySelector('.rz-product-grid');
      if (!loader || !grid || !loader.getAttribute('data-next-url')) return;

      collectionSection.dataset.rzInfiniteReady = 'true';
      collectionSection.classList.add('rz-infinite-enabled');
      var loading = false;

      function restorePagination() {
        collectionSection.classList.remove('rz-infinite-enabled');
        loader.classList.remove('is-loading');
        observer.disconnect();
      }

      function loadNextPage() {
        var nextUrl = loader.getAttribute('data-next-url');
        if (loading || !nextUrl) return;

        loading = true;
        loader.classList.add('is-loading');

        fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (response) {
            if (!response.ok) throw new Error('Could not load more products.');
            return response.text();
          })
          .then(function (html) {
            var nextDocument = new DOMParser().parseFromString(html, 'text/html');
            var nextSection = nextDocument.querySelector('[data-rz-collection-grid]');
            var nextGrid = nextSection && nextSection.querySelector('.rz-product-grid');
            if (!nextGrid) throw new Error('Product grid was not found.');

            Array.from(nextGrid.children).forEach(function (card) {
              grid.appendChild(card);
            });

            var nextLoader = nextSection.querySelector('[data-rz-infinite-scroll]');
            var followingUrl = nextLoader && nextLoader.getAttribute('data-next-url');
            if (followingUrl) {
              loader.setAttribute('data-next-url', followingUrl);
            } else {
              loader.removeAttribute('data-next-url');
              observer.disconnect();
              loader.remove();
            }

            syncWishlistButtons();
          })
          .catch(function () {
            restorePagination();
          })
          .finally(function () {
            loading = false;
            loader.classList.remove('is-loading');
          });
      }

      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) loadNextPage();
      }, { rootMargin: '600px 0px' });

      observer.observe(loader);
    });
  }

  document.addEventListener('click', function (event) {
    var buyNow = event.target.closest('[data-rz-buy-now]');
    if (buyNow) {
      event.preventDefault();
      if (buyNow.disabled) return;
      var buyForm = buyNow.closest('form');
      if (!buyForm) return;
      buyNow.disabled = true;
      fetch(buyForm.action, {
        method: 'POST',
        body: new FormData(buyForm),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Could not start checkout.');
        window.location.assign('/checkout');
      }).catch(function () {
        buyNow.disabled = false;
      });
      return;
    }

    var wishButton = event.target.closest('[data-rz-wishlist-toggle]');
    if (wishButton) {
      event.preventDefault();
      var wishCard = wishButton.closest('[data-rz-product-card]');
      if (wishCard) toggleWishlist(wishCard);
      return;
    }

    var productFavourite = event.target.closest('[data-rz-product-favourite]');
    if (productFavourite) {
      event.preventDefault();
      toggleWishlistById(
        productFavourite.getAttribute('data-product-id'),
        productFavourite.getAttribute('data-product-handle')
      );
      return;
    }

  });

  document.addEventListener('DOMContentLoaded', function () {
    syncWishlistButtons();
    initializeCardGalleries(document);
    initializeInfiniteScroll();
  });
  document.addEventListener('rz:products:rendered', function () {
    syncWishlistButtons();
    initializeCardGalleries(document);
    initializeInfiniteScroll();
  });
  document.addEventListener('shopify:section:load', function () {
    syncWishlistButtons();
    initializeCardGalleries(document);
    initializeInfiniteScroll();
  });

  if ('MutationObserver' in window) {
    var productObserver = new MutationObserver(function (mutations) {
      var hasNewCards = mutations.some(function (mutation) {
        return Array.from(mutation.addedNodes).some(function (node) {
          if (node.nodeType !== 1) return false;
          return node.matches('[data-rz-product-card]') || node.querySelector('[data-rz-product-card]');
        });
      });
      if (!hasNewCards) return;
      syncWishlistButtons();
      initializeCardGalleries(document);
    });
    productObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  syncWishlistButtons();
  initializeCardGalleries(document);
  initializeInfiniteScroll();
})();
